module.exports = __webpack_public_path__ + "img/10.74e643b3.png";